import React from 'react';
import { Flex, Box } from '@atlaskit/primitives/compiled';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { JiraIcon } from '@atlaskit/logo';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';

// This should only render during development. This makes it obvious there has been a top-level suspense when we didn't want one.
// When this renders, the render looks like blank-page -> logo -> page skeleton -> page content. The logo would typically be rendered for under a second while the network call resolves. This makes it look like a render bug when it appears and then quickly disappears.
// When it renders nothing, it looks like blank-page -> blank-page -> page skeleton -> page content. End-users should be none the wiser that we were still preparing to render, or at least have fewer tiers of placeholder.
export const JiraLogoPlaceholder = (props: { reason?: string }) => {
	const isNotProd = useIsStagingOrDevOrLocal();
	return isNotProd ? (
		<Flex justifyContent="center" alignItems="center">
			<Box padding="space.1000">
				<JiraIcon
					label={`Loading Jira... ${props.reason || ''}`}
					testId="page-container-v2.common.ui.page-container.placeholder"
				/>
				<UFOLoadHold name="jira-spa" />
			</Box>
		</Flex>
	) : null;
};
